// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatArea--YKYBTPRs{display:flex;flex-direction:column;flex:1;min-height:0;height:100%;background:rgba(248,250,252,0.5);border-radius:16px;overflow:hidden;box-shadow:0px 0px 0px 1px rgba(0,0,0,0.06)}.chatContent--TopyzJBe{flex:1;min-height:0;overflow:hidden;position:relative;padding:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatArea": `chatArea--YKYBTPRs`,
	"chatContent": `chatContent--TopyzJBe`
};
export default ___CSS_LOADER_EXPORT___;
